import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import SecuredApps from '@piwikpro/apps-crate/components/SecuredApps';
import AppDetails from '../../../administration/src/components/Apps/AppDetails';

const SecuredAppDetails = () => (
  <SecuredApps component={AppDetails} />
);

export const Route = createFileRoute('/_secured/administration/apps/$appId')({
  component: SecuredAppDetails,
});
